import getLogger, { Logger } from '../../logger.ts';

export abstract class LoggingCodecSupport {
    protected log: Logger = getLogger('http.codec');
    #enableLoggingRequestDetails = false;

    set enableLoggingRequestDetails(enable: boolean) {
        this.#enableLoggingRequestDetails = enable;
    }

    get enableLoggingRequestDetails(): boolean {
        return this.#enableLoggingRequestDetails;
    }
}
